module.exports = __webpack_public_path__ + "img/adddd.d2798174.png";